import { axiosInstance } from "./axiosInstance";
import { API_URL } from "./type";

export const fetchGoogleEmailByAddress = async (
  emailAddress,
  pageToken,
  pagerequire = 10,
  pagenumber = 1,
) => {
  const response = await axiosInstance.get(
    `${API_URL}/api/Integration/Google/FetchEmailByAddress`,
    {
      params: {
        emailAddress,
        pageToken,
        pagerequire,
        pagenumber,
      },
    },
  );

  return response.data;
};

export const getGoogleEmailId = async () => {
  const response = await axiosInstance.get(
    `${API_URL}/api/Integration/Google/GetEmailId`,
  );

  return response.data;
};

export const downloadGoogleAttachment = async (attachmentUrl) => {
  const response = await axiosInstance.get( attachmentUrl,
    {
      responseType: "blob",
    },
  );

  return response.data;
};

export const disconnectGoogleIntegration = async () => {
  const response = await axiosInstance.post(
    `${API_URL}/api/Integration/Google/Disconnect`,
  );

  return response.data;
};

export const sendGoogleEmail = async (payload) => {
  const response = await axiosInstance.post(
    `${API_URL}/api/Integration/Google/SendEmail`,
    payload,
  );

  return response.data;
};

export const uploadFilesToS3 = async (files) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("file", file);
  });

  const response = await axiosInstance.put(
    `${API_URL}/api/Files/UploadToS3`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );

  return response.data;
};

// Outlook API calls
export const fetchOutlookEmailByAddress = async (
  emailAddress,
  pageToken,
  pagerequire = 10,
  pagenumber = 1,
) => {
  const response = await axiosInstance.get(
    `${API_URL}/api/Integration/Outlook/FetchEmailByAddress`,
    {
      params: {
        emailAddress,
        pageToken,
        pagerequire,
        pagenumber,
      },
    },
  );
  return response.data;
};

export const downloadOutlookAttachment = async (attachmentUrl) => {
  const response = await axiosInstance.get(attachmentUrl, {
    responseType: "blob",
  });
  return response.data;
};

export const sendOutlookEmail = async (payload) => {
  const response = await axiosInstance.post(
    `${API_URL}/api/Integration/Outlook/SendEmail`,
    payload,
  );
  return response.data;
};

export const getOutlookEmailId = async () => {
  const response = await axiosInstance.get(
    `${API_URL}/api/Integration/Outlook/GetEmailId`,
  );

  return response.data;
};

export const disconnectOutlookIntegration = async () => {
  const response = await axiosInstance.post(
    `${API_URL}/api/Integration/Outlook/Disconnect`,
  );
  return response.data;
};

export const searchEmail = async (email) => {
  const response = await axiosInstance.get(
    `${API_URL}/api/Integration/SearchEmail`,
    {
      params: { email },
    },
  );

  return response.data;
};